const INITIAL_STATE = {
    units: [],
    unit: {},
    unitOrderingList: [],
    filter: {
        unitId: null
    }
};

export default function unitReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'LIST_UNIT': {
            return {
                ...state,
                units: action.listUnit
            };
        }
        case 'SET_UNIT': {
            return {
                ...state,
                unit: action.unit
            };
        }
        case 'RESET_FILTER': {
            const filter = state.filter;
            filter.unitId = undefined;
            return {
                ...state,
                filter
            };
        }
        case 'LIST_UNIT_ORDERING': {
            return {
                ...state,
                unitOrderingList: action.listUnitOrdering
            };
        }
        default:
            return state;
    }
}
